import React from "react";
import { isAuthenticated, getTitleDecoration } from "utils/common";

const CardItem = ({ item }) => {
  let display = isAuthenticated()
    ? {
        summary: item.summary_login,
        title: item.title_login,
        file: item.file_small_login,
      }
    : {
        summary: item.summary_nologin,
        title: item.title_nologin,
        file: item.file_small_nologin,
      };

  display.titleDecoration = getTitleDecoration(
    item.title_decoration?.title_decoration_content
  );

  return (
    <a
      href={"/promotions/" + item.id}
      className="mb-2 d-block shadow-sm bg-white"
    >
      <div className="px-2 px-13 py-1 d-flex justify-content-between align-items-center">
        <div className="d-flex flex-fill">
          <span
            dangerouslySetInnerHTML={{ __html: display.titleDecoration }}
          ></span>

          <div className="fs-14 fw-600"> {item.effective_date && `${item.effective_date}`}{display?.title}</div>
        </div>
        <div className="d-none d-md-flex view-more min-width">
          詳細
          <span>
            <i className="bi bi-chevron-right"></i>
          </span>
        </div>
      </div>
    </a>
  );
};

export default CardItem;
